import createConfirm from './createConfirm';

export default createConfirm;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/shared/confirm/index.js